export class NotificationType {
  public static INFO: string = 'info';
  public static SUCCESS: string = 'success';
  public static WARNING: string = 'warning';
  public static DANGER: string = 'danger';
}
